import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 1024px) {
    flex-direction: column;
  }

  p {
    font-size: 20px;
    line-height: 26px;
    margin-left: 19px;

    @media (max-width: 1024px) {
      margin-top: 24px;
      font-size: 14px;
      line-height: 18px;
      margin-left: 16px;
    }
  }

  img {
    margin-top: 6px;
    width: 200px;
    height: 200px;
    object-fit: cover;

    @media (max-width: 1024px) {
      margin-left: 16px;
    }
  }
`;

const HSeals = (props) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <img src={require('assets/images/henry-seals.jpeg')} alt="" />
      <p>
        A gradiate of Harvard University, Henry is an experienced people leader. Currently Henry is
        the CHRO for Zaiko, a Japan based startup that supports creators in engaging their fans
        through digital and hybrid engagement.  He is also Japan's first foreign born human rights
        commissioner and the founder of the Legacy Foundation Japan. <br />
        <br />
        As the CHRO for Paidy, he helped them become a one of Japan's only unicorns (billion-dollar
        valuation companies) and become publicly traded in 2021. <br />
        <br />
        He has also held senior HR positions for Philip Morris International, AIG, and NN.
      </p>
    </Wrapper>
  );
};

export default HSeals;
